export default __webpack_public_path__ + "static/media/Calfrest_lock.50ff5493.svg";